import React, { Fragment, useState, useEffect } from 'react';
import { Controller } from "react-hook-form";
import Select from "react-select";
import cx from "classnames";
import DatePicker from "react-datepicker";

import { formatDate } from '../../Common/Appcommon';
import { compareToList, durationWidgetList, objectiveList, periodList } from './Constants';

const ComparisonForm = (props) => {
    let { control, errors, preFormDetail, onSearchClickRegister, data } = props;
    let [formDetail, setFormDetail] = useState(preFormDetail);
    let [durationFields, setDurationFields] = useState([]);
    let [selectedDurationField, setSelectedDurationField] = useState([]);
    let [selectedDurationType, setSelectedDurationType] = useState({});
    let [durationList, setDurationList] = useState(durationWidgetList);
    let [compareList, setCompareList] = useState(compareToList);
    let [selectedCompare, setSelectedCompare] = useState(compareToList[0]);
    let [objList, setObjList] = useState(objectiveList);
    let [selectedObjective, setSelectedObjective] = useState(objectiveList[0]);
    let [customDateData, setCustomDateData] = useState({});
    let [selectedDate, setSelectedDate] = useState({});
    let [period, setPeriod] = useState(periodList[0]);
    let [formData, setFormData] = useState({});

    useEffect(() => {
        onSearchClickRegister(processSearchCallBacks);
    });

    useEffect(() => {
        if (data !== "" && data !== undefined) {
            let comparisonData = JSON.parse(data);
            setSelectedDurationField(comparisonData['duration_field']);
            setSelectedDurationType(comparisonData['duration_type']);
            let dates = comparisonData['custom_dates'];
            let dateObjects = {};
            if (dates !== undefined) {
                Object.keys(dates).map((fieldKey, index) => {
                    let dateValue = dates[fieldKey];
                    let objValue = new Date(dateValue + "Z");
                    dateObjects[fieldKey] = objValue;
                })
            }
            let fdata = {};
            fdata['noof'] = comparisonData['noof'];
            setFormData(fdata)
            setCustomDateData(dates);
            setSelectedDate(dateObjects);
            setSelectedCompare(comparisonData['compare_by']);
            setSelectedObjective(comparisonData['objective']);
        }
    }, [data]);

    const processSearchCallBacks = async (operation, customProps = {}) => {
        let saveFormData = formData;
        saveFormData['duration_field'] = selectedDurationField;
        saveFormData['duration_type'] = selectedDurationType;
        saveFormData['custom_dates'] = customDateData;
        saveFormData['compare_by'] = selectedCompare;
        saveFormData['period'] = period;
        saveFormData['objective'] = selectedObjective;

        return JSON.stringify(saveFormData);
    }

    useEffect(() => {
        (async () => {
            if (preFormDetail.length > 0) {
                setFormDetail(preFormDetail);
                await constructSummaryFieldList(preFormDetail);
            }
        })();

    }, [preFormDetail]);

    const handleTemplateChange = async (selectedValue, objName) => {
        if (objName === "duration_field") {
            setSelectedDurationField(selectedValue);
        } else if (objName === "duration_type") {
            setSelectedDurationType(selectedValue);
        } else if (objName === "compare_to") {
            setSelectedCompare(selectedValue);
        } else if (objName === "objective") {
            setSelectedObjective(selectedValue);
        } else if (objName === "period") {
            setPeriod(selectedValue);
        }
    }

    const handleDatePickerChange = async (date, name) => {
        let scheduledDateTime = formatDate(date, "yyyy-mm-dd");
        let formInputData = customDateData;
        if (date === null) {
            formInputData[name] = '';
        } else {
            formInputData[name] = scheduledDateTime;
        }
        setSelectedDate((prevData) => ({
            ...prevData,
            [name]: date
        }));
        setCustomDateData(formInputData);
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        const regex = /^\d{0,3}$/;
        if (!regex.test(value)) {
            value = value.slice(0, -1);
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const constructSummaryFieldList = async (details) => {
        let formInfo = details[0];
        let formLabel = formInfo[2];
        let fieldDetails = details[1];
        let durationField = [];
        let defaultDur = {};
        fieldDetails.map((field, index) => {
            let fieldType = field[4];
            let fieldName = field[2];
            let fieldLabel = field[3];
            console.log("fieldType: "+fieldType)
            if (fieldType === "Date_Time" || (fieldType === "form_history" && fieldName.indexOf("username") < 0)) {
                let listvalue = { value: fieldName, label: fieldLabel + " - " + formLabel };
                durationField.push(listvalue);
            }
        });
        setDurationFields(durationField);
    }
    return (
        <Fragment>
            <div className='mt-3'>

                <div className={cx('input-section mt-1')}>
                    <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="duration_field">Duration</label>
                    <div className='d-flex-alone'>
                        <div className={cx('', { 'col-md-12 pl-0 pr-0': Object.keys(selectedDurationField).length <= 0 }, { 'col-md-6': Object.keys(selectedDurationField).length > 0 })}>
                            <Controller
                                name="duration_field"
                                control={control}
                                rules={{ required: Object.keys(durationFields).length === 0 ? "Please choose duration" : false }}
                                render={({ field }) => {
                                    return (
                                        <Select
                                            {...field}
                                            placeholder={'---Choose One---'}
                                            menuPlacement={"auto"}
                                            menuPosition={'fixed'}
                                            name="duration_field"
                                            id="duration_field"
                                            className={`basic-multi-select ${errors.duration_field ? 'is-invalid' : ''}`}
                                            classNamePrefix="wa-select"
                                            value={selectedDurationField}
                                            onChange={e => {
                                                handleTemplateChange(e, 'duration_field');
                                                field.onChange(e);
                                            }}
                                            options={durationFields}
                                        />
                                    );
                                }}
                            />
                            {errors.duration_field && <em className={`error invalid-feedback`}>{errors.duration_field.message}</em>}
                        </div>
                        <div className={cx('', { 'hide': Object.keys(selectedDurationField).length <= 0 }, { 'col-md-6': Object.keys(selectedDurationField).length > 0 })}>
                            <Controller
                                name="duration_type"
                                control={control}
                                rules={{ required: Object.keys(selectedDurationType).length === 0 ? "Please choose duration" : false }}
                                render={({ field }) => {
                                    return (
                                        <Select
                                            {...field}
                                            placeholder={'---Choose One---'}
                                            menuPlacement={"auto"}
                                            menuPosition={'fixed'}
                                            name="duration_type"
                                            id="duration_type"
                                            className={`basic-multi-select ${errors.duration_type ? 'is-invalid' : ''}`}
                                            classNamePrefix="wa-select"
                                            value={selectedDurationType}
                                            onChange={e => {
                                                handleTemplateChange(e, 'duration_type');
                                                field.onChange(e);
                                            }}
                                            options={durationList}
                                        />
                                    );
                                }}
                            />
                            {errors.duration_type && <em className={`error invalid-feedback`}>{errors.duration_type.message}</em>}
                        </div>
                    </div>
                </div>
                {Object.keys(selectedDurationType).length > 0 && selectedDurationType.value === "Custom" &&
                    <div className='d-flex-alone mt-3'>

                        <div className='col-md-6'>
                            <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="dur_from">From</label>
                            <div className={cx('input-section')}>
                                <Controller
                                    name="dur_from"
                                    control={control}
                                    rules={{ required: selectedDate['dur_from'] === undefined ? "Please choose a Date" : false }}
                                    render={({ field }) => {
                                        return (
                                            <DatePicker
                                                {...field}
                                                selected={selectedDate["dur_from"]}
                                                name={"dur_from"}
                                                id={"dur_from"}
                                                popperPlacement="top"
                                                placeholder="YYYY-MM-DD"
                                                onChange={(e) => {
                                                    handleDatePickerChange(e, "dur_from");
                                                }}
                                                autoComplete='off'
                                                className={`form-control ${errors.dur_from ? 'is-invalid' : ''}`}
                                                dateFormat="yyyy-MM-dd"
                                            />
                                        );
                                    }}
                                />
                                {errors.dur_from && <em className={`error invalid-feedback`}>{errors.dur_from.message}</em>}

                            </div>
                        </div>
                        <div className='col-md-6'>
                            <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="dur_to">To</label>
                            <div className={cx('input-section')}>
                                <Controller
                                    name="dur_to"
                                    control={control}
                                    rules={{ required: selectedDate['dur_to'] === undefined ? "Please choose a Date" : false }}
                                    render={({ field }) => {
                                        return (
                                            <DatePicker
                                                {...field}
                                                selected={selectedDate["dur_to"]}
                                                name={"dur_to"}
                                                id={"dur_to"}
                                                popperPlacement="top"
                                                placeholder="YYYY-MM-DD"
                                                onChange={(e) => {
                                                    handleDatePickerChange(e, "dur_to");
                                                }}
                                                autoComplete='off'
                                                className={`form-control ${errors.dur_to ? 'is-invalid' : ''}`}
                                                dateFormat="yyyy-MM-dd"
                                            />
                                        );
                                    }}
                                />
                                {errors.dur_to && <em className={`error invalid-feedback`}>{errors.dur_to.message}</em>}

                            </div>
                        </div>
                    </div>
                }
                {Object.keys(selectedDurationType).length > 0 && selectedDurationType.value === "Last" &&
                    <div className='d-flex-alone mt-3'>
                        <div className='col-md-6'>
                            <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="noof">Last</label>
                            <div className={cx('input-section')}>
                                <Controller
                                    name="noof"
                                    control={control}
                                    rules={{ required: selectedDate['noof'] === undefined ? "Please choose a Date" : false }}
                                    render={({ field }) => {
                                        return (
                                            <input
                                                {...field}
                                                type="text"
                                                name="noof"
                                                id="noof"
                                                value={formData.noof}
                                                autoComplete={"off"}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    onInputChange(e);
                                                }}
                                                className={`form-control ${errors.noof ? 'is-invalid' : ''}`}
                                            />
                                        );
                                    }}
                                />
                                {errors.noof && <em className={`error invalid-feedback`}>{errors.noof.message}</em>}

                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className={cx('input-section')}>
                                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="period">.</label>
                                <Controller
                                    name="period"
                                    control={control}
                                    rules={{ required: Object.keys(period) === 0 ? "Please choose a Date" : false }}
                                    render={({ field }) => {
                                        return (
                                            <Select
                                                {...field}
                                                placeholder={'---Choose One---'}
                                                menuPlacement={"auto"}
                                                menuPosition={'fixed'}
                                                name="period"
                                                id="period"
                                                className={`basic-multi-select ${errors.period ? 'is-invalid' : ''}`}
                                                classNamePrefix="wa-select"
                                                value={period}
                                                onChange={e => {
                                                    handleTemplateChange(e, 'period');
                                                    field.onChange(e);
                                                }}
                                                options={periodList}
                                            />
                                        );
                                    }}
                                />
                                {errors.period && <em className={`error invalid-feedback`}>{errors.period.message}</em>}

                            </div>
                        </div>
                    </div>
                }
                <div>
                    <span className='config-title f18 mt-3'>
                        Comparison Indicator
                    </span>
                    <div className={cx('input-section mt-3')}>
                        <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="compare_to">Compare To</label>
                        <Controller
                            name="compare_to"
                            control={control}
                            rules={{ required: Object.keys(selectedCompare).length === 0 ? "Please choose a compare property" : false }}
                            render={({ field }) => {
                                return (
                                    <Select
                                        {...field}
                                        placeholder={'---Choose One---'}
                                        menuPlacement={"auto"}
                                        menuPosition={'fixed'}
                                        name="compare_to"
                                        id="compare_to"
                                        isDisabled={Object.keys(selectedDurationField).length <= 0}
                                        className={`basic-multi-select ${errors.compare_to ? 'is-invalid' : ''}`}
                                        classNamePrefix="wa-select"
                                        value={Object.keys(selectedCompare).length === 0 ? compareList[0] : selectedCompare}
                                        onChange={e => {
                                            handleTemplateChange(e, 'compare_to');
                                            field.onChange(e);
                                        }}
                                        options={compareList}
                                    />
                                );
                            }}
                        />
                        {errors.compare_to && <em className={`error invalid-feedback`}>{errors.compare_to.message}</em>}

                    </div>
                    {Object.keys(selectedCompare).length > 0 && selectedCompare.value === "Custom" &&
                        <div className='d-flex-alone mt-3'>

                            <div className='col-md-6'>
                                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="compare_from">From</label>
                                <div className={cx('input-section')}>
                                    <Controller
                                        name="compare_from"
                                        control={control}
                                        rules={{ required: selectedDate['compare_from'] === undefined ? "Please choose a Date" : false }}
                                        render={({ field }) => {
                                            return (
                                                <DatePicker
                                                    {...field}
                                                    selected={selectedDate["compare_from"]}
                                                    name={"compare_from"}
                                                    id={"compare_from"}
                                                    popperPlacement="top"
                                                    placeholder="YYYY-MM-DD"
                                                    onChange={(e) => {
                                                        handleDatePickerChange(e, "compare_from");
                                                    }}
                                                    autoComplete='off'
                                                    className={`form-control ${errors.compare_from ? 'is-invalid' : ''}`}
                                                    dateFormat="yyyy-MM-dd"
                                                />
                                            );
                                        }}
                                    />
                                    {errors.compare_from && <em className={`error invalid-feedback`}>{errors.compare_from.message}</em>}

                                </div>
                            </div>
                            <div className='col-md-6'>
                                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="compare_date_to">To</label>
                                <div className={cx('input-section')}>
                                    <Controller
                                        name="compare_date_to"
                                        control={control}
                                        rules={{ required: selectedDate['compare_date_to'] === undefined ? "Please choose a Date" : false }}
                                        render={({ field }) => {
                                            return (
                                                <DatePicker
                                                    {...field}
                                                    selected={selectedDate["compare_date_to"]}
                                                    name={"compare_date_to"}
                                                    id={"compare_date_to"}
                                                    popperPlacement="top"
                                                    placeholder="YYYY-MM-DD"
                                                    onChange={(e) => {
                                                        handleDatePickerChange(e, "compare_date_to");
                                                    }}
                                                    autoComplete='off'
                                                    className={`form-control ${errors.compare_date_to ? 'is-invalid' : ''}`}
                                                    dateFormat="yyyy-MM-dd"
                                                />
                                            );
                                        }}
                                    />
                                    {errors.compare_date_to && <em className={`error invalid-feedback`}>{errors.compare_date_to.message}</em>}

                                </div>
                            </div>
                        </div>
                    }
                    <div className={cx('input-section mt-3')}>
                        <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="objective">Objective</label>
                        <Controller
                            name="objective"
                            control={control}
                            rules={{ required: Object.keys(selectedCompare).length === 0 ? "Please choose a compare property" : false }}
                            render={({ field }) => {
                                return (
                                    <Select
                                        {...field}
                                        placeholder={'---Choose One---'}
                                        menuPlacement={"auto"}
                                        menuPosition={'fixed'}
                                        name="objective"
                                        id="objective"
                                        isDisabled={Object.keys(selectedDurationField).length <= 0}
                                        className={`basic-multi-select ${errors.objective ? 'is-invalid' : ''}`}
                                        classNamePrefix="wa-select"
                                        value={Object.keys(selectedObjective).length === 0 ? objList[0] : selectedObjective}
                                        onChange={e => {
                                            handleTemplateChange(e, 'objective');
                                            field.onChange(e);
                                        }}
                                        options={objList}
                                    />
                                );
                            }}
                        />
                        {errors.objective && <em className={`error invalid-feedback`}>{errors.objective.message}</em>}

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default React.memo(ComparisonForm);